import { NavLink } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { visibleRoutes } from '@/lib/routes';
import { useAuth } from '@/hooks/useAuth';

// Mobile "More" page — shows all routes not in the 4-tab bottom nav.
// On desktop this route is reachable but redundant with the sidebar.
export function More() {
  const { user, role, logout } = useAuth();
  const routes = visibleRoutes(role);
  const groups = (['Today', 'Analyze', 'Operate'] as const)
    .filter((g) => routes.some((r) => r.group === g));

  return (
    <div className="p-4 lg:p-6">
      <h1 className="text-xl font-bold mb-6">More</h1>
      <div className="flex flex-col gap-6 max-w-md">
        {groups.map((group) => (
          <div key={group}>
            <div className="label mb-2">{group}</div>
            <div className="card !p-0 overflow-hidden">
              {routes.filter((r) => r.group === group).map((r, idx, arr) => (
                <NavLink
                  key={r.path}
                  to={r.path}
                  className={`flex items-center gap-3 px-4 py-3 text-sm hover:bg-surface-2 transition-colors ${
                    idx < arr.length - 1 ? 'border-b border-[color:var(--border)]' : ''
                  }`}
                >
                  <div className="w-8 h-8 rounded-md bg-surface-3 grid place-items-center text-text-dim">
                    <r.icon size={16} />
                  </div>
                  <span className="flex-1">{r.label}</span>
                </NavLink>
              ))}
            </div>
          </div>
        ))}

        <div>
          <div className="label mb-2">Account</div>
          <div className="card !p-0 overflow-hidden">
            <div className="flex items-center gap-3 px-4 py-3 border-b border-[color:var(--border)]">
              <div className="w-8 h-8 rounded-md bg-surface-3 grid place-items-center text-[10px] font-bold text-text-dim">
                {(user ?? 'OP').slice(0, 2).toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold truncate">{user ?? 'Operator'}</div>
                <div className="text-[10px] text-text-faint">paper trading</div>
              </div>
            </div>
            <button
              type="button"
              onClick={() => void logout()}
              className="w-full flex items-center gap-3 px-4 py-3 text-sm text-kam-red hover:bg-surface-2 transition-colors text-left"
            >
              <div className="w-8 h-8 rounded-md bg-surface-3 grid place-items-center">
                <LogOut size={16} />
              </div>
              <span>Sign out</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
